import React, { useState } from 'react';

import { Label } from '@atlaskit/form';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Toggle from '@atlaskit/toggle';

import ExampleBox from '../shared/example-box';

export default function Example(): React.JSX.Element {
	const [rowSpace, setRowSpace] = useState<'space.300' | undefined>(undefined);
	const toggleSpace = () => {
		setRowSpace(rowSpace === 'space.300' ? undefined : 'space.300');
	};

	return (
		<Stack alignInline="start" space="space.500">
			<Inline alignBlock="center">
				<Label htmlFor="toggle-space">Toggle space between rows</Label>
				<Toggle id="toggle-space" onChange={toggleSpace} />
			</Inline>
			<Inline space="space.200" rowSpace={rowSpace} shouldWrap>
				{[...Array(24).keys()].map((index) => (
					<ExampleBox key={index} />
				))}
			</Inline>
		</Stack>
	);
}
